




































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Decisions from "@/store/modules/Decisions";
import TemplateLaunchDialog from '@/components/apps/TemplateLaunchDialog.vue';
import LaunchAppLoadingDialog from '@/components/apps/LaunchAppLoadingDialog.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import DecisionShareDialog from '@/components/decisions/DecisionManageUsersDialog.vue';
import { Urls } from "@/Urls";
import moment from 'moment';
import { type } from "os";

const decisionsModule = getModule(Decisions);

@Component({
    name: 'DecisionManagerActions',
    components: {
        ConfirmationDialog,
        DecisionShareDialog,
        TemplateLaunchDialog,
        LaunchAppLoadingDialog
    }
})

export default class DecisionManagerActions extends Vue {
    @Prop()
    selectedDecision: any;

    private loadingDialog = false;
    private decisionSelectorMenuShow: boolean = false;

    get isTemplateEnabled(): boolean {
        return (this.selectedDecision && this.selectedDecision.templateEnabled) || false;
    }

    private async deleteDecision(decisionId: string) {
        await decisionsModule.deleteDecision(decisionId);
    }

    private async pasteDecision(payload: any) {
        try {
            this.loadingDialog = true;
            await decisionsModule.copyIntoNewDecision({decision: this.selectedDecision, params: payload})
        } catch (err) {
            console.log(err)
        }
        this.loadingDialog = false;
    }

    private cloneDecision(decisionId: string ) {
        console.log(decisionId)
        this.$router.push({ 
            path: Urls.CLONING_DECISION,
            query: {
                'decision-id': decisionId,
                'include-user': 'true',
                'include-choices': 'true',
                'include-viewpoints': 'true',
                'include-apps': 'true',
                'include-lists': 'true',
                'include-comments': 'true'
            }
        })
    }

    private launchDecision(decision: any) {
        decisionsModule.selectDecision(decision.decisionId);
        this.$router.push({ path: Urls.TEMPLATE_BUILDER })
    }
}
